import { Injectable } from '@angular/core';
import { BackendConfig } from './backend-config';
import { Config } from './config-type';
import { environment } from 'src/environments/environment';

// Import config.json
// import configJson from './config.json';

// const config = <Config>(<any>configJson);

// const config = <Config><any>configJson;

type DataConfig = {
    baseUri: string;
};

type AuthConfig = {
    requiredGroup: string;
};

type ChangelogConfig = {
    uri: string;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    constructor() { }

    public get backend(): BackendConfig {
        return {
            baseUri: environment.config.backend.baseUri,
            loginPath: environment.config.backend.loginPath,
            tokenPath: environment.config.backend.tokenPath,
            redirectUri: window.location.hostname.startsWith('localhost') ? `http://${window.location.hostname}:${window.location.port}` : `https://${window.location.hostname}`,
            clientId: environment.config.backend.clientId,
            clientSecret: environment.config.backend.clientSecret
        };
    }

    public get data(): DataConfig {
        return environment.config.data;
    }

    // public get auth(): AuthConfig {
    //     return config.auth;
    // }

    // public get changelog(): ChangelogConfig {
    //     return config.changelog;
    // }

    public get version(): string {
        return environment.version ?? '';
    }
}
